import mobx, { extendObservable, action } from 'mobx';
import axios from 'axios';
import { includes, map } from 'lodash';
import eb from '../utils/EventBus'
import fileDownload from 'react-file-download';
import {properties} from '../environments';

const BLOCK_CHAIN_URL = properties.BLOCKCHAIN_URL;

class DocGrpStore {

    constructor() {
        extendObservable(this, {
            loading: true,
            filteredDocs: [],
            docs:[],
            searchTerm: ''
        });

        eb.on('search-docgrp', (val) => this.setSearch(val));
    }


   loadDocGrps = () => {
        axios.get('/api/v1/docgrp/grps').then(({ data }) => {
            this.loading = false;
            this.docs = data;
            this.filteredDocs = data;
        });
    }

   loadDocGrpDtl = (grpId) => {

        axios.get(`/api/v1/docgrp/${grpId}`).then(({ data }) => {
            this.loading = false;
            this.docs = data;
            this.filteredDocs = data;
        });
    }



    dwnld= async ( req, res) =>  {


            let fileId = this.selectedDoc.docid;

            // Get BC token
            const token = await this.getBlockChainToken(this.username, this.orgName);

            // Set up the input params needed for download from BC in options variable
            const options = {
                method: 'GET',
                headers: { 'Authorization': `Bearer ${token.token}`, 'Content-Type': 'application/json' },
                url: `${BLOCK_CHAIN_URL}/api/v1/download_file/${fileId}`
            };

            //console.log(options);

            // End point call using AJAX
            axios(options).then((response) => {
                   fileDownload(new Buffer(response.data), this.selectedDoc.docname);
            }).catch(err => {
                    console.log(err);
            });

    }

   setSearch = action((val) => {
        this.searchTerm = val;
        this.filteredDocs = this.docs.filter(i => JSON.stringify(i).toLowerCase().indexOf(val.toLowerCase()) > -1);
   })

}

const dgrpstore = new DocGrpStore();
export default dgrpstore;



// WEBPACK FOOTER //
// ./src/store/docgrp-store.js